import { motion } from 'motion/react';
import { Container, Mark } from './primitives';

const DEMO_MAILTO = `mailto:m.angelozzi@bossai.build?subject=${encodeURIComponent('Prenotazione demo BOSS')}`;

export function CTA() {
  return (
    <section id="demo" className="relative py-28 md:py-36">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[28px] border border-input bg-card px-8 py-20 md:px-20 md:py-28"
        >
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                'radial-gradient(50% 80% at 10% 100%, color-mix(in oklch, var(--primary) 22%, transparent), transparent 70%), radial-gradient(40% 70% at 95% 0%, color-mix(in oklch, var(--brand-accent) 16%, transparent), transparent 60%)',
            }}
          />
          <div
            aria-hidden
            className="blueprint-grid absolute inset-0 opacity-[0.04]"
            style={{ maskImage: 'radial-gradient(60% 60% at 50% 50%, black, transparent 80%)' }}
          />

          <div className="relative">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-primary">
              · Inizia oggi
            </div>
            <h2 className="boss-display mt-5 text-balance text-[52px] md:text-[96px]">
              Il tuo prossimo <Mark>cantiere</Mark> merita <br className="hidden md:block" />
              un sistema operativo migliore.
            </h2>
            <p className="mt-7 max-w-xl text-pretty text-[16px] leading-[1.55] text-fg-2">
              Un fondatore ti accompagna nella piattaforma, imposta un pilota su un cantiere reale, e sta
              accanto ai tuoi capocantiere per le prime due settimane. Niente teatro di gara.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href={DEMO_MAILTO}
                className="group inline-flex items-center gap-2 rounded-md bg-primary px-6 py-3 text-[15px] font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90"
              >
                Prenota una demo di 30 minuti
                <span className="transition-transform group-hover:translate-x-1">→</span>
              </a>
              <a
                href={DEMO_MAILTO}
                className="inline-flex items-center gap-2 rounded-md border border-input bg-background/40 px-6 py-3 text-[15px] text-foreground transition-colors hover:bg-secondary"
              >
                m.angelozzi@bossai.build
              </a>
            </div>
            <p className="mt-3 text-[12px] text-fg-disabled">
              Il bottone apre la tua app di posta. Se non succede nulla, copia l'indirizzo e scrivici tu.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-6 border-t border-border pt-7 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:max-w-2xl md:grid-cols-4">
              <Fact label="Risposta" value="< 12h" />
              <Fact label="Pilota" value="14 giorni" />
              <Fact label="Dati" value="In UE" />
              <Fact label="Lingue" value="IT · EN" />
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}

function Fact({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-fg-disabled">{label}</div>
      <div className="mt-1 text-foreground">{value}</div>
    </div>
  );
}
